//messageBar actions
export const FINISH_YOUR_BETS = 'FINISH_YOUR_BETS';
export const NO_MORE_BETS = 'NO_MORE_BETS';

export const ACTIVE_BETS_TAB = 0;
export const SETTLED_BETS_TAB = 1;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/constants/identifiers.js